// PDF React View
import { yupResolver } from "@hookform/resolvers/yup";
import { generateInputField } from "helpers/form_helper_old";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Button,
  Col,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import * as yup from "yup";

const ChangeInfoModal = props => {
  const { isOpen, toggle, tchat, dataChange, isShowBtnUpdate, onUpdate } =
    props;

  useEffect(() => {
    if (isOpen) {
      let data = {};
      for (const key in dataChange) {
        if (key !== "index") {
          let label = "";
          switch (key) {
            case "nmua_dchi":
              label = "Địa chỉ";
              break;
            case "noidung":
              label = "Nội dung";
            default:
              break;
          }
          const splitNew = key.split("_new");
          const splitOld = key.split("_old");

          const keyNew = splitNew.length === 2 ? splitNew[0] : null;
          const keyOld = splitOld.length === 2 ? splitOld[0] : null;

          const keyMain = keyNew ? keyNew : keyOld;

          const isNew = keyNew ? true : false;

          const labelChild = `${label} ${
            isNew ? "đúng:" : "trên hóa đơn bị sai:"
          }`;
          const finalValue = isShowBtnUpdate
            ? dataChange[key]
            : dataChange[key]?.split(labelChild)[1]?.trim() || "";

          if (data[keyMain]) {
            data[keyMain] = {
              ...data[keyMain],
              [isNew ? "new" : "old"]: finalValue,
            };
          } else {
            data = {
              ...data,
              [keyMain]: {
                [isNew ? "new" : "old"]: finalValue,
              },
            };
          }
          setValue(key, finalValue);
        }
      }
      delete data.noidung;
      setDataShow(data);
    }
  }, [isOpen]);

  const [dataShow, setDataShow] = useState({});

  const tchatTbaoLabel = {
    1: "hủy",
    2: "điều chỉnh",
    3: "thay thế",
    4: "giải trình",
  };

  const objSchema = {};
  const schema = yup.object().shape(objSchema);
  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
  });

  const onSubmit = values => {
    const data = values;
    delete data.index;
    onUpdate && onUpdate(data);
    toggle();
  };

  return (
    <Modal
      size="xl"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      style={{ maxWidth: "80%" }}
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          <Label>Nội dung sai sót bổ sung trong mail</Label>
        </ModalHeader>
        <ModalBody>
          <div>
            {dataChange?.nmua_dchi_old ? (
              <React.Fragment>
                {isShowBtnUpdate && (
                  <span
                    className="text-success"
                    style={{
                      fontSize: "15px",
                      fontStyle: "italic",
                      fontWeight: "bold",
                    }}
                  >
                    Lưu ý: Nếu không nhập nội dung đúng (bên phải) thì trường dữ
                    liệu đó sẽ không gửi trong mail
                  </span>
                )}
                <div>
                  {Object.entries(dataShow).map(([key, value]) => {
                    let label = "";
                    switch (key) {
                      case "nmua_dchi":
                        label = "Địa chỉ";
                        break;
                      default:
                        break;
                    }
                    return (
                      <Row key={key}>
                        {Object.entries(value).map(([keyChild, valueChild]) => {
                          const isNew = keyChild === "new";
                          const labelChild = `${label} ${
                            isNew ? "đúng" : "trên hóa đơn bị sai"
                          }`;
                          return (
                            <Col className="mb-2" key={keyChild}>
                              {generateInputField(
                                labelChild,
                                false,
                                "textarea",
                                errors,
                                touchedFields,
                                `${key}_${keyChild}`,
                                `Nhập ${labelChild}`,
                                register,
                                isNew ? (isShowBtnUpdate ? false : true) : true
                              )}
                            </Col>
                          );
                        })}
                      </Row>
                    );
                  })}
                </div>
              </React.Fragment>
            ) : (
              // <span className="text-danger" style={{ fontSize: "18px" }}>
              //   Không có nội dung bổ sung
              // </span>
              <div></div>
            )}
            <Row>
              <Col className="mb-2">
                {generateInputField(
                  "Nội dung bị sai",
                  false,
                  "textarea",
                  errors,
                  touchedFields,
                  `noidung_old`,
                  `Nhập nội dung đúng`,
                  register,
                  !isShowBtnUpdate
                )}
              </Col>
              <Col className="mb-2">
                {generateInputField(
                  "Nội dung đúng",
                  false,
                  "textarea",
                  errors,
                  touchedFields,
                  `noidung_new`,
                  `Nhập nội dung sai`,
                  register,
                  !isShowBtnUpdate
                )}
              </Col>
            </Row>
          </div>
        </ModalBody>
        <ModalFooter>
          {isShowBtnUpdate && (
            <Button
              type="button"
              color="primary"
              className="me-2 btn-label"
              onClick={() => {
                handleSubmit(onSubmit)();
              }}
            >
              <i className="bx bx-edit label-icon" />
              Cập nhật nội dung
            </Button>
          )}

          <Button
            type="button"
            color="danger"
            className="me-2"
            onClick={toggle}
          >
            Đóng
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
};

ChangeInfoModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  isShowBtnUpdate: PropTypes.bool,
  dataChange: PropTypes.any,
  tchat: PropTypes.any,
  onUpdate: PropTypes.any,
};

ChangeInfoModal.defaultProps = {
  isShowBtnUpdate: false,
};

export default ChangeInfoModal;
